export enum AvailableUpdateStatus {
  UNKNOWN = 0,
  NONE = 1,
  OPTIONAL = 2,
  MANDATORY = 3
}
